import { render } from "./indexTwo.vue?vue&type=template&id=3cac297a"
import script from "./indexTwo.vue?vue&type=script&lang=js"
export * from "./indexTwo.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__